<template>
    <mounting-portal mount-to="#portalvue-sections-component">
        <div
            v-if="true === sectionsEnabled"
            class="mt-60px">
            <section-component
                v-for="section,sectionIndex in sections"
                :key="sectionIndex"
                :section="section">
            </section-component>
        </div>
    </mounting-portal>
</template>

<script>
import SectionComponent from './SectionComponent.vue'

export default{
    props: ['data'],
    data() {
        return {
            isActive: false,
        }
    },
    computed: {
        sectionsEnabled() {
            return this.sections.length > 0 &&
                true === this.isActive
        },
        sections() {
            return JSON.parse(this.data)
        }
    },
    components: {
        SectionComponent
    },
    methods: {
        handleScrollEvent() {
            const top = document.documentElement.scrollTop
            const wrapper = document.querySelector('.section-component')

            if (undefined !== wrapper) {
                const el = wrapper.offsetTop - window.innerHeight * 2

                if(false === this.isActive && top > el) {
                    this.isActive = true;
                    document.removeEventListener('scroll', this.handleScrollEvent(), true)
                }
            }
        }
    },
    mounted() {
        this.handleScrollEvent()

        if (false === this.isActive) {
            document.addEventListener('scroll', this.handleScrollEvent, true)
        }
    },
    destroyed() {
        document.removeEventListener('scroll', this.handleScrollEvent, true)
    }
}
</script>
